import { render, staticRenderFns } from "./orderDeleteAll.vue?vue&type=template&id=511e9980&"
import script from "./orderDeleteAll.vue?vue&type=script&lang=js&"
export * from "./orderDeleteAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports